export class WithheldIncomeTax {
  id: number;
  min: number = 0.0;
  max: number;
  base: number = 0.0;
  rate: number = 0.0;
  is_married: boolean = false;
}
